/* eslint-disable prefer-destructuring */
export default (url) => {
    const parsedStrings = {};
    const query = url.substring(window.location.href.indexOf('?') + 1).split('&');
    query.forEach((element) => {
        const [key, value] = element.split('=');
        parsedStrings[key] = value;
    });
    return parsedStrings;
};
